import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { GfTitleService } from '../../../../services/core.title.service';
import * as _ from 'lodash';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProjectAdminTrackerDeleteComponent } from './projectAdminTrackerDelete/project.admin.tracker.delete.component';
import { StateService } from '@uirouter/angular';

@Component({
  selector: 'project-admin-tracker',
  template: require('./project.admin.tracker.html')
})
export class ProjectAdminTrackerComponent implements OnInit, OnChanges {
  @Input() project: any;
  @Input() isProjectAdmin: boolean;

  trackerData: any[] = [];
  isLoading: boolean = true; // Set to true by default

  constructor(
    private titleService: GfTitleService, 
    private modalService: NgbModal,
    private stateService: StateService
  ) { }

  ngOnInit() {
    this.titleService.setTitle(this.project.name, 'Admin', 'Trackers');
    this.loadTrackerData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.project && changes.project.currentValue) {
      this.loadTrackerData();
    }   
  }

  loadTrackerData() {
    this.isLoading = true;
    if (this.project && this.project.rel && this.project.rel.trackers) {
      this.trackerData = _.get(this.project, 'rel.trackers', []);
    } else {
      this.trackerData = [];
    }
    this.isLoading = false;
  }

  deleteTrackerCallback(deletedTracker: any) {
    if (!deletedTracker || !this.project || !this.project.rel || !this.project.rel.trackers) {
      return;
    }

    _.remove(this.project.rel.trackers, { tracker_id: deletedTracker.tracker_id });
    this.trackerData = [...this.project.rel.trackers];
  }

  private getProjectUnixName(): string | undefined {
    return this.project?.unixName
      || this.project?.unix_name
      || this.stateService?.params?.unixName;
  }


  showDeleteTracker(tracker: any) {
    const modalRef = this.modalService.open(ProjectAdminTrackerDeleteComponent);
    modalRef.componentInstance.tracker = tracker;
    modalRef.componentInstance.onDelete.subscribe((deletedTracker: any) => {
      this.deleteTrackerCallback(deletedTracker || tracker);
      modalRef.close();
    });
    modalRef.componentInstance.onClose.subscribe(() => {
      modalRef.close();
    });
  }

  goToTrackerAdd() {
    const unixName = this.getProjectUnixName();
    this.stateService.go('home.project.summary.admin.tracker.add', unixName ? { unixName } : undefined);
  }
}
